export default __webpack_public_path__ + "static/media/ServiceComment.b13706b2.svg";